import { Box, makeStyles } from '@material-ui/core';
import { ReactNode } from 'react';
import { ResultTitle } from './EntityTitle';

type EntitySummaryProps = {
  leading?: ReactNode;
  title: string;
  location: string;
  breadcrumbs?: ReactNode;
};

const useStyles = makeStyles(
  theme => ({
    root: {
      whiteSpace: 'normal',
    },
    headerContainer: {
      display: 'flex',
      gap: theme.spacing(1),
      alignItems: 'center',
    },
  }),
  { name: 'EntitySummary' },
);

export const EntitySummary = ({
  leading,
  title,
  breadcrumbs,
  location,
}: EntitySummaryProps) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.headerContainer}>
        {leading}
        <ResultTitle title={title} location={location} />
      </Box>
      {breadcrumbs}
    </Box>
  );
};
